// extracted by mini-css-extract-plugin
module.exports = {"businessYoutubeEmbedContainer":"business-youtube-embed_businessYoutubeEmbedContainer__va9Ky","youtubeVideo":"business-youtube-embed_youtubeVideo__7qktS"};